<template>
  <div class="popup__header">
    <CurrencyPicker v-if="isShowCurrency" />
    <h3 class="popup__title">{{ $t("points.header") }}</h3>
    <div class="popup__header-button">
      <div class="close" @click.prevent="closePopup"></div>
    </div>
  </div>
</template>
<script>
import CurrencyPicker from "../../Common/CurrencyPicker";
import env from "@libs/util/environment";

export default {
  name: "PointsHeader",
  components: {
    CurrencyPicker,
  },
  computed: {
    isShowCurrency() {
      return env.isMyGames();
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>
